import type { AllocationPreviewStatus } from '@/features/Collaborators/Models';

export interface AllocationStatusMetadata {
    title: string;
    description: string;
    icon: string;
    badgeClass: string;
}

export const ALLOCATION_STATUS_ORDER: AllocationPreviewStatus[] = [
    'Allocated',
    'IdleUpcoming',
    'NeedsReallocation',
    'Idle',
    'Absence'
];

export const ALLOCATION_STATUS_METADATA: Record<AllocationPreviewStatus, AllocationStatusMetadata> = {
    Absence: {
        title: 'Ausentes',
        description: 'Colaboradores ausentes',
        icon: '🛌',
        badgeClass: 'bg-yellow-100 text-yellow-800 border border-yellow-200'
    },
    NeedsReallocation: {
        title: 'Precisa de alocação',
        description: 'Colaboradores que ficarão ociosos em até 30 dias',
        icon: '🔄',
        badgeClass: 'bg-amber-100 text-amber-700 border border-amber-200'
    },
    Idle: {
        title: 'Ociosos',
        description: 'Colaboradores ociosos',
        icon: '⏸️',
        badgeClass: 'bg-rose-100 text-rose-700 border border-rose-200'
    },
    IdleUpcoming: {
        title: 'Alocação prevista',
        description: 'Ociosos com alocação iniciando em breve',
        icon: '🕒',
        badgeClass: 'bg-orange-100 text-orange-700 border border-orange-200'
    },
    Allocated: {
        title: 'Alocados',
        description: 'Colaboradores alocados',
        icon: '✅',
        badgeClass: 'bg-emerald-100 text-emerald-700 border border-emerald-200'
    }
};

export const getAllocationStatusRank = (status?: AllocationPreviewStatus | null): number => {
    if (!status) return ALLOCATION_STATUS_ORDER.length;
    const position = ALLOCATION_STATUS_ORDER.indexOf(status);
    return position === -1 ? ALLOCATION_STATUS_ORDER.length : position;
};

export const getAllocationStatusTitle = (status?: AllocationPreviewStatus | null): string => {
    if (!status) return '';
    return ALLOCATION_STATUS_METADATA[status]?.title ?? status;
};

export const getAllocationStatusDescription = (status?: AllocationPreviewStatus | null): string => {
    if (!status) return '';
    return ALLOCATION_STATUS_METADATA[status]?.description ?? '';
};
